import { Box, Typography } from "@mui/material"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { If } from "lib/@components/switch"
import { TruncatedTypography } from "lib/@components/truncated-typography"

export function RejectionUpdatedBy({ payload }) {
    const { user, date } = payload ?? {}

    const updatedDate = date ? new Date(date).format(DATE_FORMATS.long) : ""

    return (
        <If value={user}>
            <Box display="flex" alignItems="center">
                <TruncatedTypography
                    variant="caption"
                    sx={{
                        color: "text.secondary",
                        fontWeight: "bold",
                        minWidth: 0,
                    }}
                >
                    {user}
                </TruncatedTypography>
                <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: "bold" }}>
                    ,
                </Typography>
                <Typography variant="caption" sx={{ color: "text.secondary", flexShrink: 0, ml: 0.5 }}>
                    {updatedDate}
                </Typography>
            </Box>
        </If>
    )
}
